export default __webpack_public_path__ + "static/media/ninetyPercentageThreshold.f0c63586.svg";